<nz-spin [nzSpinning]="true" nzTip="It's being redirected...">
    <div style="height: 100vh;width: 100vw;"></div>
</nz-spin>